export default function renderAdrPageNoV3() {
  return function (pdf) {
    pdf.setFont("helvetica", "normal").setFontSize(8);
    pdf.text(pdf.internal.getNumberOfPages().toString(), 580, 25);
  };
}
